module.exports = __webpack_public_path__ + "media/images/icons/delete-22d671d6442db8dafb12760986182d7c.svg";